import { withRouter, Link } from "react-router-dom"
import React, { useEffect, useState } from "react"
import {
  Card,
  Button,
  CardBody,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import { changeLeaguesStatus, changeLeaguesTopStatus } from "helpers/repository"
import TableLoader from "../../../../components/Common/TableLoader"
import { useSelector, useDispatch } from "react-redux"
import { deleteCampaign } from "store/Campaigns/actions"
import { hasPermission } from "helpers/helpers"
function Table(props) {
  const [isOpen, setIsOpen] = useState(false)
  const dispatch = useDispatch()

  const handleEdit = (row, e) => {
    e.preventDefault()
    props.history.push(`${window.location.pathname}/edit?id=${row.id}`)
  }

  const { data } = props
  const columns = [
    {
      dataField: "id",
      text: "ID",
      sort: true,
      formatter: (cellContent, row) => {
        return row.id
      },
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
      formatter: (cellContent, row) => (
        <>
          {row.name ? row.name : ""}
          <i
            className="mdi mdi-information font-size-18"
            id={`addtooltip${row?.id}`}
          />
          <UncontrolledTooltip
            placement="top"
            target={`addtooltip${row?.id}`}
            style={{ width: "100%" }}
          >
            <p style={{ marginBottom: "0px", textAlign: "left" }}>
              Message: {row.message ? row.message : ""}
            </p>
          </UncontrolledTooltip>
        </>
      ),
    },
    {
      dataField: "startDate",
      text: "Start Date",
      sort: true,
      formatter: (cell, row) => {
        const date = new Date(row?.startDate)
        const formattedDate = date.toLocaleString("en-GB", {
          timeZone: "CAT",
          hour12: true,
        })
        const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
          match.toUpperCase()
        )
        return <>{capitalizedDate}</>
      },
    },
    {
      dataField: "endDate",
      text: "End Date",
      sort: true,
      formatter: (cell, row) => {
        const date = new Date(row?.endDate)
        const formattedDate = date.toLocaleString("en-GB", {
          timeZone: "CAT",
          hour12: true,
        })
        const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
          match.toUpperCase()
        )
        return <>{capitalizedDate}</>
      },
    },
    {
      dataField: "first_user_count",
      text: "First Send Count",
      sort: true,
    },
    {
      dataField: "second_user_count",
      text: "Second Send Count",
      sort: true,
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      formatter: (cell, row) => (
        <>
          {row.status == 0
            ? "Pending"
            : row.status == 1
            ? "Partial"
            : row.status == 2
            ? "Complete"
            : "Pending"}
        </>
      ),
    },

    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      formatter: (cellContent, row) => (
        <>
          <div className="d-flex gap-3">
            {hasPermission("update-campaign") && (
              <Link
                to="#"
                className="text-success"
                onClick={e => handleEdit(row, e)}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Edit
                </UncontrolledTooltip>
              </Link>
            )}

            {hasPermission("delete-campaign") && (
              <Link
                to="#"
                className="text-danger"
                onClick={e => {
                  dispatch(deleteCampaign(row.id))
                  props.getCampaigns()
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Delete
                </UncontrolledTooltip>
              </Link>
            )}
          </div>
        </>
      ),
    },
  ]

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ]
  const { SearchBar } = Search

  const pageOptions = {
    sizePerPage: 20,
    totalSize: props.count,
    custom: true,
  }

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      setIsOpen(true)
    },
  }

  const handleClick = () => {
    console.log("hello")
    props.history.push("/crm/content/campaigns/create")
  }
  return (
    <>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">{"Campaigns"}</div>
          {props.loadingMessage && props.loadingMessage == "1" ? (
            <TableLoader />
          ) : (
            <PaginationProvider
              pagination={paginationFactory(pageOptions)}
              keyField="id"
              columns={columns}
              data={data}
            >
              {({ paginationProps, paginationTableProps }) => (
                <ToolkitProvider
                  keyField="id"
                  data={data}
                  columns={columns}
                  bootstrap4
                  search
                >
                  {toolkitProps => (
                    <React.Fragment>
                      <Row className="mb-2">
                        <Col sm="6">
                          <Row>
                            <Col sm="6">
                              <div className="search-box me-2 mb-2 d-inline-block">
                                <div className="position-relative">
                                  <SearchBar {...toolkitProps.searchProps} />
                                  <i className="bx bx-search-alt search-icon" />
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col sm="6">
                          {hasPermission("create-campaign") && (
                            <div className="text-sm-end">
                              <Button
                                type="button"
                                color="success"
                                className="btn-rounded  mb-2 me-2"
                                onClick={handleClick}
                              >
                                <i className="mdi mdi-plus me-1" />
                                Create New Campaign
                              </Button>
                            </div>
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col xl="12">
                          <div className="table-responsive">
                            <BootstrapTable
                              keyField="id"
                              responsive
                              bordered={false}
                              striped={false}
                              defaultSorted={defaultSorted}
                              //   selectRow={selectRow}
                              classes={
                                "table align-middle table-nowrap table-check"
                              }
                              headerWrapperClasses={"table-light"}
                              {...toolkitProps.baseProps}
                              {...paginationTableProps}
                              rowClasses={"mytable-hover-row"}
                              rowEvents={rowEvents}
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="pagination pagination-rounded justify-content-end">
                        <PaginationListStandalone {...paginationProps} />
                      </div>
                    </React.Fragment>
                  )}
                </ToolkitProvider>
              )}
            </PaginationProvider>
          )}
        </CardBody>
      </Card>
    </>
  )
}

export default withRouter(Table)
